export default {
  methods: {
    getApplicantPayload (applicant = null) {
      const entity = applicant || this.applicant
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Applicant',
        resource_id: entity.resource_id || entity.id
      }
    },

    getPositionPayload (position = null) {
      const entity = position || this.position
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Position',
        resource_id: entity.id
      }
    },

    getCompanyPayload (company = null) {
      const entity = company || this.company
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Company',
        resource_id: entity.resource_id || entity.id || entity.user_id
      }
    },

    getOfferPayload (offer = null) {
      const entity = offer || this.offer
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Offer',
        resource_id: entity.id
      }
    },

    getOperatorPayload (operator = null) {
      const entity = operator || this.operator
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Operator',
        resource_id: entity.resource_id || entity.id || entity.user_id
      }
    },

    getApplicantPayloadForGhanaFlag (applicant = null) {
      const entity = applicant || this.applicant
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Applicant',
        resource_id: entity.resource_id || entity.id
      }
    },

    getPositionPayloadForGhanaFlag (position = null) {
      const entity = position || this.position
      if (!entity) return null

      return {
        ...entity,
        resource_type: 'Position',
        resource_id: entity.id
      }
    }
  }
}
